module.exports = __webpack_public_path__ + "static/media/C-DAC.05ff9cea.png";